import { EntityApi, LoopBackAuth } from '../../../sdk';
import { FormBuilder } from '@angular/forms';
import { AbstractWidgetComponent, isNotEmpty, touppercase } from '../../../utils/util';
import { Component, OnInit, OnDestroy, Input, OnChanges } from '@angular/core';
//import 'ag-grid-enterprise/main';
import { ChartApi } from '../../../sdk/services/custom';
import * as _ from 'lodash';
import { SimpleNotificationsComponent, NotificationComponent, PushNotificationsService, NotificationsService } from 'angular2-notifications';
import { PlatformApp } from '../../../services/app.service';
@Component({
    selector: 'chart',
    templateUrl: './chart.component.html',
    styleUrls: ['./chart.component.scss']

})

export class ChartComponent implements OnInit, OnDestroy, OnChanges {
    @Input() id: string;
    @Input() setup: any;
    @Input() options: any;
    @Input() dataprovider: any;
    @Input() cardWrapper: boolean = true;

    private subscriptions: any = [];
    private chart: any = {};
    private height: any = 300;
    private width: any = 100;
    private label: any = 'Chart';
    private targetSVG = "M9,0C4.029,0,0,4.029,0,9s4.029,9,9,9s9-4.029,9-9S13.971,0,9,0z M9,15.93 c-3.83,0-6.93-3.1-6.93-6.93S5.17,2.07,9,2.07s6.93,3.1,6.93,6.93S12.83,15.93,9,15.93 M12.5,9c0,1.933-1.567,3.5-3.5,3.5S5.5,10.933,5.5,9S7.067,5.5,9,5.5 S12.5,7.067,12.5,9z";

    constructor(private _ChartApi: ChartApi) { }

    ngOnInit() {
        this.changeChart();
    }
    ngOnChanges() {
        this.changeChart();
    }

    ngOnDestroy() {
    }

    changeChart() {
        if (this.options) this.options = JSON.parse(JSON.stringify(this.options));

        if (this.dataprovider) {
            if (this.options && this.options.type && this.options.type == "stock" && this.options.dataSets && this.options.dataSets[0]) {
                this.options.dataSets[0].dataProvider = JSON.parse(JSON.stringify(this.dataprovider));
            }
            else {
                this.options.dataProvider = JSON.parse(JSON.stringify(this.dataprovider));
            }
        }

        if (this.setup) {
            if (this.setup.label) { this.label = this.setup.label; }
            if (this.setup.height) { this.height = Number(this.setup.height); }
            if (this.setup.width) { this.width = Number(this.setup.width); }
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/widgets/chart/chart.component.ts